import { render, staticRenderFns } from "./UsuarioTrocarSenha.vue?vue&type=template&id=764d3ae2&scoped=true&"
import script from "./UsuarioTrocarSenha.vue?vue&type=script&lang=js&"
export * from "./UsuarioTrocarSenha.vue?vue&type=script&lang=js&"
import style0 from "./UsuarioTrocarSenha.vue?vue&type=style&index=0&id=764d3ae2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764d3ae2",
  null
  
)

export default component.exports